import React, { Component } from "react"
import { noYes, oneTill8, oneTill12plus, houseOwner } from "../../variables/ComboValues";
import { updateElement } from "../Tree/Utils.js"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'

//import { digmaDate, searchTableFilter } from "./Utils.js"
//import { EditableCell } from "../TableList/EditableCell"

// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB
export const  Housing_microLegend = {
    "family_house": "סוג הדיור",
    "family_persons_athome": "מס. נפשות בבית",
    "family_room_num": "מס חדרים",
    "family_house_status": "נדרש טיפול בדירה?",
    "family_housing_comment": "הערות למצב הדירה"
}

export class FamilyHousing extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)

    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)

        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      //console.log("Family general this.state.products=", this.state.products)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            
            headerColumns = {[ "family_house", "family_persons_athome", "family_room_num", "family_house_status", 
                      "family_housing_comment"]}
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
      var buttonStyle = {marginRight: '0'}
      // console.log("General - products", products)
      
      var product = ""
      var cellData = []
      if (typeof products !== "undefined"){
          product = products
          cellData=[{
            type: "select",
            options: houseOwner, // ["דירה בבעלותנו","אצל ההורים","דיור ציבורי","בשכירות","דמי מפתח", "סיוע בשכ''ד משרד השיכון","אחר"],
            name: "family_house",
            value: product.family_house,
            id: product.id,
            style: {width: "260px"},
            edit: true
          },{
            type: "select",
            options: oneTill12plus, // ["1","2","3","4","5","6","7","8","9","10","11","12+"],
            name: "family_persons_athome",
            value: product.family_persons_athome,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: oneTill8, // ["1","2","3","4","5","6","7","8"],
            name: "family_room_num",
            value: product.family_room_num,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "family_house_status",
            value: product.family_house_status,
            id: product.id,
            style: {width: "160px"},
            edit: true
          },{
            type: "textarea",
            name: "family_housing_comment",
            value: product.family_housing_comment,
            id: product.id,
            style: {width: "300px"},
            edit: true
          }]  

      }
      return (
        <div className="yahav-modal">
            <h2 className="sub-tab-title">{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left  update-button" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform width1140" >
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    product={product} 
                    cd={cellData}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd} = this.props
      var key = 0;
      return (
        <div className="eachRow" >

          {cd.map(cellInfo => {
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} /> )
          })}
  
        </div>
      )
  
    }
  
  }
  
  class EditableFormCell extends React.PureComponent {
    render() {
        const tp = this.props
        const tpc = tp.cellData
        //const divStyle= {padding: 0, verticalAlign: 'top', borderTop: 0, display: 'inline-block', margin: '0 3px 0 8px' }
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{Housing_microLegend[tpc.name]}</label><br />
              <SelectF tp={tp} tpc={tpc} overstyle={{verticalAlign : 'top'}}  />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{Housing_microLegend[tpc.name]}</label><br />
              <TextareaF tp={tp} tpc={tpc} />
            </div>
          )
        }
        return (
          <div className="form-cell-box-inline">
            <label  htmlFor={tpc.id}>{Housing_microLegend[tpc.name]}</label><br />
            <InputF tp={tp} tpc={tpc} />
          </div>
        )
  
    }
  }
